<template>
  <section class="faq-widget grid">
    <WidgetHeading
      class="title t-h2"
      :content="widget.title"
      :is-first="isFirst"
    />
    <div class="questions">
      <button
        v-for="(item, i) in widget.items"
        :key="`${item.question}_${i}`"
        class="question-button t-p-m-130"
        :class="{ active: currentContent.question === item.question }"
        @click="showQuestion(i)"
        v-html="nbsp(item.question)"
      />
    </div>
    <div v-if="currentContent" class="content">
      <p class="question t-h6" v-html="nbsp(currentContent.question)" />
      <div class="answer t-p-m-160" v-html="nbsp(currentContent.answer)" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { PublicFaqWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicFaqWidget>>()

const activeIndex = ref(0)

const dummyContent = {
  question: '',
  answer: ''
}
const currentContent = computed(
  () => props.widget.items?.[activeIndex.value] ?? dummyContent
)
const showQuestion = (index: number) => (activeIndex.value = index)
</script>

<style lang="scss" scoped>
.title {
  @include column(xs, 12);
  margin-bottom: rem(52px);
}

.questions {
  @include media-column(
    (
      xs: 12,
      s-lg: 6
    )
  );
  display: flex;
  flex-wrap: wrap;
  gap: rem(8px);
  margin-bottom: rem(36px);

  @include media-up(s-lg) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0;
  }
}

.question-button {
  padding: rem(10px) rem(18px);
  text-align: left;
  background-color: $layout-background-02;
  border-radius: $border-radius-big;
  box-shadow: $button-shadow;
  transition: background-color $transition;

  &.active,
  &:hover {
    background-color: $global-sun-04;
  }
}

.content {
  @include media-column(
    (
      xs: 12,
      s-lg: 6 6
    )
  );
}

.question {
  margin-block: rem(8px) rem(32px);
}

.answer {
  hyphens: manual;
  color: $layout-text-02;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
